import ApiProduct from '@/api/Product'
import RequestMixin from '@/mixins/request'

export default {
    mixins: [RequestMixin],
    data () {
        return {
            filtersLoaded: false,
            filters: []
        }
    },
    computed: {
        isDynamicCategoryPage () {
            return false
        }
    },
    methods: {
        loadFilters () {
            return this.performRequest(ApiProduct.getFilters(this.$axios), { handle404: false })
                .then(response => {
                    this.filters = response.data.data
                    if (this.isDynamicCategoryPage) this.filters = this.filters.filter(e => e.name !== 'category')
                    this.filters = this.addAdditionalDataToFilters(this.filters)
                    this.hasFeatureFilter = this.filters.some(x => x.name === 'feature')
                    setTimeout(() => { this.filtersLoaded = true }, 0)
                })
                .catch(error => {
                    console.error(error)
                    this.filters = []
                })
        },
        addAdditionalDataToFilters (filters) {
            return filters.map(filter => {
                if (['multiselection', 'multiselection_ranges'].includes(filter.type)) {
                    filter.active = false
                    filter.showMore = false
                } else if (filter.type === 'range') {
                    filter.active = false
                    filter.from = filter.values.min
                    filter.to = filter.values.max
                    filter.values.active = false
                } else if (filter.type === 'checkbox') {
                    filter.active = false
                    filter.values.active = false
                } else if (filter.type === 'multiselection_tree') {
                    filter.active = false
                    filter.showMore = false
                }
                return filter
            })
        }
    }
}